export default __webpack_public_path__ + "static/media/flag-armenia.cf52f6e7.svg";